import { takeLatest, put, call } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { safe } from '@app/react/saga/common/safe';
import {
    fetchFamilyCrestList,
    FetchFCListParam,
} from '@app/react/action/FetchFamilyCrestList';
import { api } from '@app/react/common/api';
import {
    DesignSet,
    GetResponseOrderParts,
    OrdermadeArrowPartsName,
} from '@app/react/const/type';
import { conv, convArrowType, convOrderType } from '@app/react/saga/conv';

type FetchAPIRT = { result: GetResponseOrderParts | null, error: Response | null };

const fetchAPI = () => {
    const selectedItems = conv({ carving: null, familycrest: null } as DesignSet);
    const json = JSON.stringify(selectedItems);
    // ヘルプ用なので固定
    const at = convArrowType('kinteki');
    const ot = convOrderType('full');

    /*
     * query parameterの一部をjson形式にしているため、型エラーが出ます
     */
    return api.orderMadeFunctionGetOrderPartsGet({
        kind: OrdermadeArrowPartsName.Familycrest,
        arrowType: at,
        orderType: ot,
        selectedItems: json,
    });
};

function* fetchFamilycrestList(action: Action<FetchFCListParam>) {
    const { result: familycrest, error }: FetchAPIRT = yield safe(call(fetchAPI));
    if (error !== null || familycrest === null) {
        console.error('[saga] fetch familycrest error:', error);
        yield put(
            fetchFamilyCrestList.failed({
                params: action.payload,
                error: {
                    message: error?.statusText ?? '',
                },
            }),
        );
        return;
    }

    yield put(
        fetchFamilyCrestList.done({
            params: action.payload,
            result: {
                items: familycrest,
            },
        }),
    );
}

export const orderPartsHelpFetchSaga = [
    takeLatest(fetchFamilyCrestList.started.type, fetchFamilycrestList),
];
